import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, Button } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import { LanguageProvider } from '../../core/language-provider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityCompiler from '../../components/Modals/ModalEntityCompiler';



export default function DataGridLastTdHook({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()
    const userInfo = LoginManager.getUserInfo();


    //gyv_order
    function printOrder() {
        navigate('/page/OrderPrint?id='+item.id)
    }
    async function editOrder(order) {
        var response = await DataManager.getItem('customer_order', order.id)
        if(response.success === 1) {
            setModalCompilerInitData(response.body[0])
        }
    }
    const [modalCompilerStatus, setModalCompilerStatus] = useState(false)
    const [modalCompilerInitData, setModalCompilerInitData] = useState(null)
    function closeModalCompiler() {
        setModalCompilerInitData(null)
    }

    useEffect(() => {
        if(modalCompilerInitData !== null) {
            setModalCompilerStatus(true)
        }
        else {
            setModalCompilerStatus(false)
        }
    }, [modalCompilerInitData]);

    async function modalCompilerSave(el) {
        console.log('el',el,modalCompilerInitData)

        // update
        var response = await DataManager.updateItem('customer_order', el, modalCompilerInitData.id);
        if(response.success === 1) {
            refreshData()
        }
        else {
            console.warn(response)
        }
        setModalCompilerInitData(null)
    }


    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'gyv_order': return (
                            <>
                                {parseInt(userInfo.level) === 0 ? (
                                    <Button onClick={() => editOrder(item)} size='sm' variant='dark' className='mx-1'>Modifica</Button>
                                ) : null}

                                {modalCompilerStatus ? (
                                    <ModalEntityCompiler entity={'customer_order'} initData={modalCompilerInitData} close={closeModalCompiler} status={modalCompilerStatus} confirmCallback={modalCompilerSave} />
                                ) : null}

                                {parseInt(userInfo.level) === 0 ? (
                                    <a target="_blank" href={"https://b2b-api.trivek.it/metodo/downloadOrder.php?id=" + item.id + "&c=" + item.idCustomer + "&d=" + (item.destination ? String(item.destination).trim().split(' ')[0] : '')}>
                                        <Button size='sm' variant='primary' className='mx-1'>CSV Metodo</Button>
                                    </a>
                                ) : null}
                                
                                <Button onClick={() => printOrder()} size='sm' variant='secondary' className='mx-1'><FontAwesomeIcon icon="print" /></Button>
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};